import Page from '@pages/Page.js';
import { notLoggedIn, title } from '@mixins';
export default {
  mixins: [notLoggedIn, title],
  extends: Page
};
